export default __webpack_public_path__ + "static/media/Plant States.7f744c53.png";